import { ExperienceFeatures, IEventSettings } from '@interfaces/event';

// The only assistant the hub ships a UI for. An experience that names anything
// else keeps the AI toggle off as far as the hub is concerned.
export const SUPPORTED_VIRTUAL_ASSISTANT_NAME = 'Noa';

/**
 * Reports whether the AI assistant belongs on screen for the loaded experience.
 *
 * Single source of truth for that gate: `HomeBottomBar` mounts the whole
 * `AssistantProvider` subtree behind it and `MytaverseEventProvider` tears the
 * assistant's audio down when it flips to false (MV-1816). Both read this so
 * the gate and the teardown cannot drift — a name change alone unmounts the
 * subtree just as `features.AI_ASSISTANT.enabled: false` does.
 *
 * @param currentEventId - Experience the participant is inside; falsy while none is loaded.
 * @param settings - `settings` of the loaded experience.
 * @returns `true` only while the assistant is enabled and named `Noa`.
 */
export const isAIEnabledForEventSettings = (
  currentEventId: string | null | undefined,
  settings: IEventSettings | undefined,
): boolean =>
  !!(
    currentEventId &&
    settings?.features?.[ExperienceFeatures.AiAssistant]?.enabled === true &&
    settings?.aiVirtualAssistantName === SUPPORTED_VIRTUAL_ASSISTANT_NAME
  );
